import { render, staticRenderFns } from "./ReviewContent.vue?vue&type=template&id=0d7ace32"
import script from "./ReviewContent.vue?vue&type=script&lang=js"
export * from "./ReviewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports